import React from 'react'
import { Route } from "react-router";
import Projects from '../pages/project/Projects';
import ProjectForm from '../pages/project/ProjectForm';
import Emergency from '../pages/emergency/Emergency';
import EmergencyForm from '../pages/emergency/EmergencyForm';
import Utilities from '../pages/utilities/Utilities';
import UtilitiesForm from '../pages/utilities/UtilitiesForm';
import Concrete from '../pages/concrete/Concrete';
import ConcreteForm from '../pages/concrete/ConcreteForm';
import EarthWork from '../pages/earthwork/Earthwork';
import EarthWorkForm from '../pages/earthwork/EarthWorkForm';
import Home from '../pages/home/Home'
import MarketAreaform from '../pages/home/MarketAreaform';
import Testimonial from '../pages/testimonial/Testimonial';
import TestimonialForm from '../pages/testimonial/TestimonialForm';
import About from '../pages/about/About';
import ProjectOrder from '../pages/project/ProjectOrder';
import Query from '../pages/query/Query';
import Dashboard from '../pages/Dashboard/Dashboard';
import ContactUs from '../pages/ContactUs/Contactus';
import Gallery from '../pages/gallery/Gallery';

const AdminRoutes = () => {
    return (
        <>
            <Route path="/" element={<Dashboard />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/home" element={<Home />} />
            <Route path="/home/market/form" element={<MarketAreaform />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/form" element={<ProjectForm />} />
            {/* <Route path="/projects/order" element={<ProjectOrder />} /> */}
            <Route path="/emergency" element={<Emergency />} />
            <Route path="/emergency/form" element={<EmergencyForm />} />
            <Route path="/utilities" element={<Utilities />} />
            <Route path="/utilities/form" element={<UtilitiesForm />} />
            <Route path="/concrete" element={<Concrete />} />
            <Route path="/concrete/form" element={<ConcreteForm />} />
            <Route path="/earthworks" element={<EarthWork />} />
            <Route path="/earthworks/form" element={<EarthWorkForm />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/aboutus" element={<About />} />
            <Route path="/testimonial" element={<Testimonial />} />
            <Route path="/query" element={<Query />} />
            <Route path="/testimonial/form" element={<TestimonialForm />} />
        </>
    )
}

export default AdminRoutes
